import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_ControlContainer from "../components/BSL_ControlContainer";
import * as BSL_Common from "../components/BSL_CommonControls";
import ManageProductListControlCodes from "./ManageProductListControlCodes";
import ManageProductListAncillary from "./ManageProductListAncillary";
import ManageDynamicCodes from "./ManageDynamicCodes";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    sl_row: {
        flex: 1,
        display: "flex",
        margin: "3px 0px",
        padding: "3px 0px",
        borderBottom: "1px dotted grey",
    },
    sl_row_header: {
        display: "flex",
        width: "100px",
    },
    sl_row_content: {
        display: "flex",
        flexWrap: "wrap",
        flex: "1",
    },
    sl_content: {
        display: "flex",
        flexDirection: "column",
        flex: "1",
    },
    sl_chip: {
        color: theme.palette.primary.main,
    },
    pair_chip: {
        color: theme.palette.primary.main,
    },
    pair_header: {
        color: theme.palette.primary.main,
        fontSize: "14px",
        fontWeight: 600,
    },
}));

export default function ManageProductListItem(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { row, action, columns, config } = props;
    const [editRow, setEditRow] = React.useState(row);
    const [value2Colours, setValue2Colours] = React.useState("");
    const [value2Image, setValue2Image] = React.useState("");
    const [showControlCodes, setShowControlCodes] = React.useState(false);
    const [showDCodes, setShowDCodes] = React.useState(false);
    const [showAncillaryItems, setShowAncillaryItems] = React.useState(false);

    // helper to get column by field name
    const getColumn = (field) => columns?.find((col) => col.field === field || col.name === field || col.id === field);

    const setValue = (parameter) => (value) => {
        setEditRow((prev) => ({ ...prev, [parameter]: value }));
    };

    let materials = window.config;

    let title = "NEW ITEM";
    let saveButtonText = "Add New";
    if (action === "EDIT") {
        title = `EDIT ${row?.ProductIndex} - ${row?.ProductDescription}`;
        saveButtonText = "Update Item";
    } else if (action === "DUPLICATE") {
        title = `DUPLICATE ${row?.ProductIndex} - ${row?.ProductDescription}`;
        saveButtonText = "Duplicate Item";
    } else if (action === "VIEW") {
        title = `VIEWING HISTORY DATA FOR ${row?.ProductIndex}`;
        saveButtonText = "CLOSE";
    }

    const handleSave = () => {
        if (!editRow.ProductIndex) return alert("Please add a Product index before saving");
        if (!editRow.ProductCode) return alert("Please add a Lyves Code before saving");
        if (!editRow.ProductDescription) return alert("Please add a Product Description before saving");
        const saveAction = action === "DUPLICATE" || action === "NEW" ? "ADD" : action;
        props.saveValue(editRow, saveAction);
    };

    return (
        <BSL_Dialog
            title={title}
            open
            button1Text={saveButtonText}
            onClose={props.onClose}
            button1Click={handleSave}
            button2Text="Cancel"
            button2Click={props.onClose}
            style={{ maxWidth: "initial" }}
            contentStyle={{ background: action === "VIEW" ? "#eeeeee" : "inherit" }}
            fullWidth
            maxWidth="md"
        >
            <BSL_Common.SectionRow>
                <BSL_Common.SectionColumn>
                    {getColumn("GroupingName")?.editor(
                        row,
                        editRow.GroupingName,
                        setValue("GroupingName"),
                        () => {},
                        "NO BUTTON"
                    )}
                    {getColumn("ProductIndex")?.editor(
                        row,
                        editRow.ProductIndex,
                        setValue("ProductIndex"),
                        () => {},
                        "NO BUTTON"
                    )}
                    {getColumn("ProductDescription")?.editor(
                        row,
                        editRow.ProductDescription,
                        setValue("ProductDescription"),
                        () => {},
                        "NO BUTTON"
                    )}
                    {getColumn("Cost")?.editor(row, editRow.Cost, setValue("Cost"), () => {}, "NO BUTTON")}
                    {getColumn("Markup")?.editor(row, editRow.Markup, setValue("Markup"), () => {}, "NO BUTTON")}
                    {getColumn("SellingUOM")?.editor(
                        row,
                        editRow.SellingUOM,
                        setValue("SellingUOM"),
                        () => {},
                        "NO BUTTON"
                    )}
                    {getColumn("Notes")?.editor(row, editRow.Notes, setValue("Notes"), () => {}, "NO BUTTON")}
                </BSL_Common.SectionColumn>
                <BSL_Common.SectionColumn>
                    {getColumn("Image_b64")?.editor(
                        row,
                        editRow.Image_b64,
                        setValue("Image_b64"),
                        () => {},
                        value2Image,
                        setValue2Image,
                        "NO BUTTON"
                    )}
                    {getColumn("Brand")?.editor(row, editRow.Brand, setValue("Brand"), () => {}, "NO BUTTON")}
                    {getColumn("ProductCode")?.editor(
                        row,
                        editRow.ProductCode,
                        setValue("ProductCode"),
                        () => {},
                        "NO BUTTON"
                    )}
                    <BSL_ControlContainer
                        label="D365 Codes"
                        style={{ color: "white", background: "antiquewhite", padding: "8px", borderRadius: "4px" }}
                        tight
                        helperText="click to edit d365 codes"
                    >
                        <div className="link" style={{ fontSize: "18px" }} onClick={() => setShowDCodes(true)}>
                            {editRow.PromptTextCodes ? (
                                getColumn("MatchedItems")?.format(editRow.MatchedItems, editRow)
                            ) : (
                                <div style={{ fontSize: "66%" }}>-Add d365 Codes-</div>
                            )}
                        </div>
                        {showDCodes && (
                            <ManageDynamicCodes
                                row={row}
                                onClose={() => setShowDCodes(false)}
                                // saveValue={saveValue}
                                saveValue={(r, p, data) => {
                                    setShowDCodes(false);
                                    setValue("MatchedItems")(data);
                                }}
                                materials={materials}
                            />
                        )}
                    </BSL_ControlContainer>
                    {getColumn("ProductGroup")?.editor(
                        row,
                        editRow.ProductGroup,
                        setValue("ProductGroup"),
                        () => {},
                        editRow.SubGroup,
                        setValue("SubGroup"),
                        "NO BUTTON"
                    )}
                    <div style={{ background: "#ecebeb" }}>
                        {getColumn("Colours")?.editor(
                            row,
                            editRow.Colours,
                            setValue("Colours"),
                            () => {},
                            value2Colours,
                            setValue2Colours,
                            "NO BUTTON",
                            editRow.Brand === "CDS" ? config.cdsOffering : config.lldOffering
                        )}
                    </div>
                    {getColumn("State")?.editor(row, editRow.State, setValue("State"), () => {}, "NO BUTTON")}
                </BSL_Common.SectionColumn>
            </BSL_Common.SectionRow>

            <BSL_Common.SectionRow>
                <BSL_ControlContainer
                    label="Ancillary Parts"
                    style={{ color: "white", background: "antiquewhite", borderRadius: "4px", padding: "8px" }}
                    tight
                    helperText="click to edit ancillary items"
                >
                    <div className="link" style={{ fontSize: "18px" }} onClick={() => setShowAncillaryItems(true)}>
                        {editRow.AncillaryParts ? (
                            getColumn("AncillaryParts")?.format(editRow.AncillaryParts, editRow)
                        ) : (
                            <div style={{ fontSize: "66%" }}>-Add Ancillary Items-</div>
                        )}
                    </div>
                    {showAncillaryItems && (
                        <ManageProductListAncillary
                            row={editRow}
                            onClose={() => setShowAncillaryItems(false)}
                            saveValue={(r, p, data) => {
                                setShowAncillaryItems(false);
                                setValue("AncillaryParts")(data);
                            }}
                            pricefileDescSummary={config.pricefileDescSummary}
                        />
                    )}
                </BSL_ControlContainer>
                <BSL_ControlContainer
                    label="Control Codes"
                    style={{ color: "white", background: "antiquewhite", padding: "8px", borderRadius: "4px" }}
                    tight
                    helperText="click to edit control codes"
                >
                    <div className="link" style={{ fontSize: "18px" }} onClick={() => setShowControlCodes(true)}>
                        {editRow.PromptTextCodes ? (
                            getColumn("PromptTextCodes")?.format(editRow.PromptTextCodes, editRow)
                        ) : (
                            <div style={{ fontSize: "66%" }}>-Add Control Codes-</div>
                        )}
                    </div>
                    {showControlCodes && (
                        <ManageProductListControlCodes
                            row={editRow}
                            onClose={() => setShowControlCodes(false)}
                            saveValue={(r, p, data) => {
                                setShowControlCodes(false);
                                setValue("PromptTextCodes")(data);
                            }}
                        />
                    )}
                </BSL_ControlContainer>
            </BSL_Common.SectionRow>
        </BSL_Dialog>
    );
}
